/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DigitizingMelcoDigitizingModelsDigitizingColorListItem,
    DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSON,
    DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSONTyped,
    DigitizingMelcoDigitizingModelsDigitizingColorListItemToJSON,
    DigitizingMelcoModelsCustomWarning,
    DigitizingMelcoModelsCustomWarningFromJSON,
    DigitizingMelcoModelsCustomWarningFromJSONTyped,
    DigitizingMelcoModelsCustomWarningToJSON,
} from './';

/**
 * 
 * @export
 * @interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem
 */
export interface DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem {
    /**
     * 
     * @type {Array<DigitizingMelcoDigitizingModelsDigitizingColorListItem>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem
     */
    list: Array<DigitizingMelcoDigitizingModelsDigitizingColorListItem>;
    /**
     * 
     * @type {Array<DigitizingMelcoModelsCustomWarning>}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem
     */
    warning_list?: Array<DigitizingMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem
     */
    total: number;
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemFromJSON(json: any): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem {
    return DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemFromJSONTyped(json, false);
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingColorListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(DigitizingMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItemToJSON(value?: DigitizingMelcoModelsGenericList1MelcoDigitizingModelsDigitizingColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(DigitizingMelcoDigitizingModelsDigitizingColorListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(DigitizingMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


